import name from './name'

const selectSliceData = state => state[name]

const selectPlaylist = state => selectSliceData(state)

// Everything the api already has a row for, external links included: playlist
// update diffs this array against the stored one and deletes any `external#`
// sk missing from it, so dropping them here silently destroys the links.
// A link staged during creation has no sk yet and must stay out until the
// create call has written it.
const selectContentUrls = state =>
  selectSliceData(state)
    .content.filter(({ sk }) => sk)
    .map(({ sk }) => sk)

// Links added before the playlist exists. Sent with the create payload so the
// api can write them once it has a playlist id.
const selectPendingExternalContent = state =>
  selectSliceData(state)
    .content.filter(({ type, pending }) => type === 'external' && pending)
    .map(({ title, description, url, image }) => ({
      title,
      description,
      url,
      image
    }))

/**
 * The thumbnail the api will fall back to when the playlist carries no upload.
 *
 * Mirrors resolveDerivedImages in nova-api
 * (services/playlist/playlist-derived-image.js): it walks the content list by
 * position and takes the first item that actually has an image — NOT the first
 * item. A playlist led by an external link whose scrape found no thumbnail
 * derives from the item after it, and the preview has to agree.
 */
const selectDerivedImage = state =>
  selectSliceData(state).content?.find(item => item?.image?.imgUrl)?.image

const selectBack = state => selectSliceData(state).back || {}

const selectContentCount = state => selectSliceData(state).content?.length ?? 0

const selectPlaylistIds = state => selectSliceData(state).playlistIds

const selectContentReadTimes = state => selectSliceData(state).readTimes

export { selectPlaylist, selectContentUrls, selectPendingExternalContent, selectDerivedImage, selectBack, selectContentCount, selectPlaylistIds, selectContentReadTimes }
